export enum EXCHANGE_RATES_STATUS {
  ACTIVE = 'Active',
  DELETE = 'Deleted',
  DRAFT = 'Draft',
}
